// extracted by mini-css-extract-plugin
export default {"button":"UploadTrigger_button__72eN4"};